module.exports = __webpack_public_path__ + "static/fonts/Cairo/static/Cairo-Regular.ttf";